export default __webpack_public_path__ + "static/media/ticket-protection.180a9e68.svg";